// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__A-TUx","label":"Completed_label__1wjf6"};